(function(){
    // Added a custom event
    $(document).bind("theme:spr:refresh", function(){
        if(window.SPR){
            // refresh badges and product section
            window.SPR.initDomEls();
            window.SPR.loadBadges();
            window.SPR.loadProducts();
        }
    });
    //The event can be triggered from any function as needed by using below code
    //$(document).trigger("theme:spr:refresh");
})();

$(document).ajaxSuccess(function() {
    $('.js-option, .product-options').on('click change',function () {
        $(this).closest('.product-miniature').addClass('no-fade-effect');
    });
});
function an_accordion() {
    var  accordion = $('.accordion-content').hide();
    $('.accordion-header').filter( ':first' ).addClass('active-top');
    $('.accordion-header').filter( ':first' ).next().addClass('active-bottom').slideDown("slow" );
    $('.accordion-header').on('click',function() {
        if($(this).hasClass('active-top')){
            $(this).toggleClass('active-top');
            $(this).next().toggleClass('active-bottom');
        }
        else{
            $('.accordion-header').removeClass('active-top');
            $('.accordion-content').removeClass('active-bottom');
            $(this).toggleClass('active-top');
            $(this).next().toggleClass('active-bottom');
        }
        accordion.slideUp("slow" );
        $(this).next().stop().slideToggle();
        return false;
    });
}

/*=============Product Hover Photos Slider=================*/
function owl_on_product_image() {
    $('.hover-slider').trigger('refresh.owl.carousel');
}
$(document).ready(function () {
    // collection full width button
    if($('.collection-filters-fullwidth')){
        $(document).on('click','.collection-filter-btn', function (e) {
            $('.collection-filters-fullwidth').slideToggle();
        });
    }

    //footer-js
    // grid swatches
    $('body').on('change', '.quick-view .swatch :radio, #addToCartForm .swatch :radio, #addToCartFormFooter .swatch :radio', function() {
        var optionIndex = jQuery(this).parents('.swatch').data('option-index');
        var optionValue = jQuery(this).val();
        jQuery(this)
            .parents('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
    });
    $('body').on('click', 'label.swatch-image', function() {
        jQuery(this).parent().find('input').prop('checked', true).trigger('change');
    });
    var selectCallback = function(variant, selector) {
        if (variant) {
            $('.variant-sku').text(variant.sku);
            $('.variant-barcode').text(variant.barcode);
        } else {
            $('.variant-sku').empty();
            $('.variant-barcode').empty();
        }
    };
    //scroll top
    $(function() {
        let scrollBtn = $('.scrolltopbtn');
        if( $(window).scrollTop() > 0 ) {
            scrollBtn.addClass('active');
        }
        $(window).on('scroll', function() {
            if( $(this).scrollTop() > 200 ) {
                scrollBtn.addClass('active');
            } else {
                scrollBtn.removeClass('active');
            }
        });
        scrollBtn.on('click', function() {
            $('html, body').animate({ scrollTop: 0 }, scrollBtn.attr('data-speed'));
        });
    });


    // shortcode owl
    if($('.shortcode_product_owl').length != 0){
        let sliderId = $('.shortcode_product_owl').attr('id');
        let $slider = $(`#${sliderId}`);
        let slider_count = +$slider.attr('data-count');
        $slider.owlCarousel({
            nav: true,
            navText: [,],
            lazyLoad: true,
            navRewind: false,
            margin: 20,
            responsive: {
                0: {
                    items: slider_count == 1 ? 1 : 2 ,
                    nav: true
                },
                480: {
                    items: slider_count <= 2 ? slider_count : 2 ,
                    nav: true
                },
                768:{
                    items: slider_count,
                    nav: true
                }
            }
        });
    }

    //shortcode popup
    if ( $( ".shortcode_popup" ).length ) {
        let popup = $( ".shortcode_popup" ).attr('id');
        $(`#${popup}`).magnificPopup({
            removalDelay: 500,
            callbacks: {
                beforeOpen: function() {
                    this.st.mainClass = this.st.el.attr('data-effect');
                }
            },
            type:'inline',
            midClick: true
        });
    }
    //fixed menu
    if($('.fixed_menu').length){
        let $menu = $('.header_mobile.fixed_menu');
        let headerHeight = $('.header').height();
        let fixed_pos = $menu.offset().top;

        $(window).on('scroll resize', function() {
            if ( $(this).scrollTop() > fixed_pos) {
                $('.fixed_menu').addClass('scroll');
                $('.header').height(headerHeight);
            } else {
                $('.fixed_menu').removeClass('scroll');
                $('.header').height('auto');
            }
            if($(window).outerWidth() < 1000){
                if ( $(this).scrollTop() > $menu.outerHeight() ) {
                    $menu.height( $menu.height() );
                    $menu.addClass('scroll');
                }
                else{
                    $menu.height('auto');
                    $menu.removeClass('scroll');
                }
            }
            else{
                $menu.height('auto');
                $menu.removeClass('scroll');
            }

        });
    }


    //homeslider

    var homeSliderBox = $('.homeslider');
    var homeSliderWrapp = $('.homeslider_wrapp');
    // preloader
    var $img = homeSliderBox.find('img');
    $img.on('load', function () {
        $(this).removeAttr("width")
            .removeAttr("height")
            .css({width: "", height: ""});
        var width = $(this).width();
        var height = $(this).height();
        homeSliderWrapp.css('height', height);
    });
    $img.each(function () {
        var src = $(this).attr('src');
        $(this).attr('src', '');
        $(this).attr('src', src);
    });
    let selectedCurrency = $('.currencies-dropdown').find('span.selected').filter( ':first' );
    let currencyDropdown = $('.currencies-dropdown');

    let currenciesButton = $('.currencies-btn');
    let labelSelected = $('.currency-selected');

    if($('.header').hasClass('header_sixteen')){
        labelSelected.html('<span class="label">'+labelSelected.attr('data-label')+'</span>'+ selectedCurrency.text());
    }
    else{
        labelSelected.html(selectedCurrency.text());
    }
    labelSelected.addClass(selectedCurrency.text());
    currencyDropdown.on('click', ({
        target
    }) => {
        labelSelected.html(target.textContent);
        labelSelected.attr('class','');
        labelSelected.addClass('currency-selected');
        labelSelected.addClass(target.textContent);
        currencyDropdown.slideUp();
    });
    currenciesButton.on('click', () => currencyDropdown.slideToggle());

    $('.weglot_switcher.wg-drop').on('click', function () {
        $(this).addClass('closed');
        $(this).find('ul').slideToggle();
    });

    $("body").on("click",function(e){
        var target = $(e.target);
        if( target.closest('.search-bar').length != 0){
        }
        else{
            if($(window).outerWidth()> 991){
                $('.search-bar-content').removeClass('open');
            }
        }
        if(target.parent().hasClass('wg-li') || target.closest(".weglot_here").length != 0){
            return;
        }
        else{
            $('.weglot_here').addClass('closed');
            $('.weglot_here').find('ul').slideUp();
        }
        if(target.parent().hasClass('currencies-dropdown') || target.closest(".currencies-btn").length != 0 || target.closest(".currencies-dropdown").length != 0 ){
            return;
        }
        else{
            currencyDropdown.slideUp();
        }

        if(target.closest(".search_full_width").length != 0 ||  target.closest(".header-search-btn").length != 0 ){
            return;
        }
        else{
            if($(window).outerWidth()>768){
                $(".header-search .search_full_width").slideUp();
                $(".header-search .overlay").fadeOut();
                $('body').css('overflow','visible');
            }

        }
        if( target.closest('.header-navigation-vertical').length != 0 || $("body").hasClass("template-index")){
            return;
        }
        else{
            $(".vertical-manu-header").next('.vertical-menu').slideUp();
        }

    });


    /*===============Vertical megamenu===================*/
    $('.vertical-manu-header').on('click',function () {
        $(this).next('.vertical-menu').slideToggle();
    });
    $('.visible-items .site-nav--has-dropdown, ' +
        '.hide-items .site-nav--has-dropdown, ' +
        '.visible-items .has-megamenu, ' +
        '.hide-items .has-megamenu').on('click',function (e) {
        if($(window).width()< 1000){
            $(this).find('.vertical-menu-wrap').toggleClass('open_item');
            $(this).find('.site-nav__dropdown').toggleClass('open_item');
        }
    });
    $(".newsletter_checkbox").on('change',function(){
        if(this.checked){
            $('.newsletter-btn').add('.btn-newsletter-popup').removeAttr('disabled', 'false');
        }else{
            $('.newsletter-btn').add('.btn-newsletter-popup').attr('disabled', 'true');
        }
    });
    $('.vertical-menu .vert-menu_show_more').on('click',function () {
        if($(this).hasClass("active")){
            $('.vert-menu_show_more').removeClass("active");
        }
        else{
            $(this).addClass("active");
        }
        $(this).prev('.hide-items').slideToggle();

    });
    /*===============Search Bar===================*/
    let searchOpenButton = $('.header-search-btn');

    $(document).on('keydown', function(key) {
        // ESCAPE key pressed
        if (key.keyCode == 27) {
            $(".header-search .search_full_width").slideUp();
            $(".header-search .overlay").fadeOut();
        }
    });

    searchOpenButton.on('click', function () {
        if($(window).outerWidth()>768){
            $(".header-search .overlay").fadeIn();
            $(".header-search .search_full_width").slideDown();
            $('body').css('overflow','hidden');
        }
    });
    $('.close_search').on('click', function () {
        if($(window).outerWidth()>768){
            $(".header-search .search_full_width").slideUp();
            $(".header-search .overlay").fadeOut();
            $('body').css('overflow','visible');
        }
    });
    function right_position() {
        if($(window).outerWidth() > 768){
            $('.an-custom-width').each(function () {
                $(this).css({ "left":"auto" , "right":"auto" });
                var this_offset_right = 0,
                    container_offset_right = 0,
                    this_offset_left = 0,
                    container_offset_left = 0;
                this_offset_right = Math.floor($(this).offset().left + $(this).outerWidth(true));
                container_offset_right = Math.floor($("#container_for_search_w").offset().left + $("#container_for_search_w").outerWidth()) + 15;
                this_offset_left = Math.floor($(this).offset().left);
                container_offset_left = Math.floor($("#container_for_search_w").offset().left);
                if (this_offset_left < container_offset_left ){
                    $(this).offset({left: container_offset_left});
                }
                if (this_offset_right > container_offset_right){
                    $(this).offset({left: container_offset_right - $(this).outerWidth(true)});
                }
            });
            $('.megamenu-wrapper.full_width').each(function () {
                $(this).offset({left:0});
            });
            if( $('.header').hasClass('header_five') || $('.header').hasClass('header_eleven')) {
                $('.drawer.header_five .mobile-nav .megamenu-wrapper').add('.drawer.header_five .mobile-nav .site-nav__dropdown').each(function () {
                    $('.drawer.drawer--left').css({"display": "block"});
                    $(this).css({"top": "0"});
                    var this_offset_bottom = Math.floor($(this).offset().top + $(this).innerHeight());
                    if (this_offset_bottom > $(window).height()) {
                        $(this).css({"top": "50%", "transform": "translateY(-50%)"});
                    }
                    if (this_offset_bottom > $(window).height()) {
                        $(this).css({"transform": "translateY(-65%)"});
                    }
                });
            }
            if( $('.header').hasClass('header_eleven')) {
                $('.sidebar_navigation .megamenu-wrapper').add('.sidebar_navigation  .site-nav__dropdown').each(function () {
                    $(this).css({"top": "0"});
                    var this_offset_bottom = Math.floor($(this).offset().top + $(this).outerHeight(true));
                    if (this_offset_bottom > $(window).height()) {
                        $(this).css({"top": "50%", "transform": "translateY(-45%)"});
                    }
                });
            }
        }
    }
    var timerId_0=false;
    right_position();
    $(window).on('resize scroll', function () {
        clearTimeout(timerId_0);
        timerId_0 = setTimeout(function () {
            right_position();
        }, 10);
    });


    /*=============Collection Filters=================*/
    
    $(window).on('load resize', function () {
        let widthWindow = $(this).outerWidth();
        if (widthWindow > 768) {
          //  $('.footer-links-list').show();
            $('.collection-filters-fullwidth.list-style .group-list').show();
        } else {
           // $('.footer-links-list').hide();
            $('.collection-filters-fullwidth.list-style .group-list').hide();
        }
    });
    $('.mobile-footer-links-title').on('click', function () {
        $(this).next('.footer-links-list').slideToggle();
        $(this).toggleClass('open');
    });

    $('.collection-filters-fullwidth.list-style .filter-title').on('click', function () {
        $(this).next('.group-list, .widget-dropdown').slideToggle();
        $(this).toggleClass('open');
    });
    $('.product-colors .product-color').each(function () {
        let color = $(this).data('color-value');
        if(color == 'white' || color == '#fff' || color == '#ffffff' ){
            $(this).children().css('border', '1px solid #dee2e6');
        }
        $(this).children().css('backgroundColor', color);
    });

    // Tabs shortcode
    if ($('.an-tabs').length) {

        $.fn.anTabsSizeCheck = function() {

            $.each( $(this), function(){
                var maxWidth = $(this).width();
                var width = 0;
                if( typeof $(this).data('width') == 'undefined' ) {
                    $(this).find('.sc-clone').each(function(){
                        width += $(this).outerWidth(true);
                    });
                    $(this).data('width', width);
                } else {
                    width = parseInt( $(this).data('width') );
                }
                if( width > maxWidth ) {
                    $(this).parent().addClass( 'collapsed' );
                } else {
                    $(this).parent().removeClass( 'collapsed' );
                }
            });
        }

        $.fn.anTabsHeightCheck = function() {
            $.each( $(this), function(){
                var height = $(this).outerHeight(true);
                $(this).parent().find('.sc-div').each(function(){
                    $(this).css('min-height', height+'px');
                });
            });
        }

        $( '.an-tabs' ).each( function() {
            var $tabs = $(this);

            if(typeof $tabs.data('processed') != 'undefined') {
                return;
            }

            $tabs.data('processed', 'true');

            var tabsHtml = '<div class="sc-tabs">';
            $tabs.find( '.sc-div' ).each(function(){
                var id = $(this).attr('id');
                var title = $(this).data('title');
                tabsHtml += '<div class="sc-clone" id="'+id+'"><a href="#'+id+'" data-tab-trigger="'+id+'" class="tab-click"><span>'+title+'</span></a></div>';
                $(this).before('<div class="sc-mobile-tab"><a href="#'+id+' "data-tab-mobile-trigger="'+id+'"><span>'+title+'</span></a></div>');
            });
            tabsHtml += '</div>';
            $tabs.prepend(tabsHtml);

            $(this).find('.sc-tabs').anTabsSizeCheck();
            if($(this).hasClass('v-tabs')) {
                $(this).find('.sc-tabs').anTabsHeightCheck();
            }
        });


        $('body').on('click','a[data-tab-trigger]', function(event) {
            event.preventDefault();
            var $tabs = $(this).parents('.an-tabs');
            $tabs.find( '.sc-tabs a' ).removeClass('active');
            $(this).addClass('active');
            var id = $(this).attr('href').replace(/^#/,'');

            $tabs.find( '.sc-div:not(#'+id+')' ).removeClass('active-tab-div').addClass('not-active-tab-div');
            $tabs.find( '.sc-div#'+id ).removeClass('not-active-tab-div').addClass('active-tab-div');
        });

        $('.an-tabs').each(function() {
            $(this).find('.sc-mobile-tab').eq(0).find('a').addClass('active');
        });
        $('body').on('click','a[data-tab-mobile-trigger]', function(event) {
            event.preventDefault();
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parent().parent().find('.sc-div').removeClass('active-tab-div').addClass('not-active-tab-div');
            } else {
                var id = $(this).data('tab-mobile-trigger');
                $('#'+id+' a.tab-click').trigger('click');
                $('a[data-tab-mobile-trigger]').removeClass('active');
                $(this).addClass('active');
                $(this).find('.sc-div:not(#'+id+')').removeClass('active-tab-div').addClass('not-active-tab-div');
                $(this).find('.sc-div#'+id).removeClass('not-active-tab-div').addClass('active-tab-div');
            }
            return false;
        });

        $('.an-tabs .sc-clone:first-child a').click();

        $( window ).resize(function(){
            $('.an-tabs .sc-tabs').anTabsSizeCheck();
            $('.an-tabs.v-tabs .sc-tabs').anTabsHeightCheck();
        });

    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires;
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
        }
        return "";
    }

    // Newsletter popup

    if ($('#newsletter-popup').length && (Boolean(getCookie('newsletter-popup')) != true)) {
        setTimeout(function() {
            if($('#newsletter-popup .form-message--success').length ){
                setCookie('newsletter-popup', true, 30);
            }
            if($('#newsletter-popup').attr('data-cookie') ){

                if($('#newsletter-popup').attr('data-cookie') == 'month'){
                    setCookie('newsletter-popup', true, 30);
                }
                if($('#newsletter-popup').attr('data-cookie') == 'session'){
                    setCookie('newsletter-popup', true);
                }
            }
            $.magnificPopup.open({
                items: {
                    src: '#newsletter-popup'
                },
                type: 'inline'
            });
        }, 2000);
    }
    // Owl slider shortcode
    if ($('.an-slider').length) {
        $(".an-slider").owlCarousel({
            nav: true,
            dots: true,
            autoplay: true,
            autoHeight: true,
            navText: [,],
            lazyLoad: true,
            loop: true,
            navRewind: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
            items: 1,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            smartSpeed: 450,
        });
    }




    //product page video 1 popup Shortcode
    if ( $( "#an-product-video-shortcode" ).length ) {
        $('#an-product-video-btn').magnificPopup({
            removalDelay: 500, //delay removal by X to allow out-animation
            callbacks: {
                beforeOpen: function() {
                    this.st.mainClass = this.st.el.attr('data-effect');
                }
            },
            type: 'inline',
            midClick: true
        });
    };

    //product page video 2 popup Shortcode
    if ( $( "#an-product-video-shortcode-2" ).length ) {
        $('#an-product-video-btn-2').magnificPopup({
            removalDelay: 500, //delay removal by X to allow out-animation
            callbacks: {
                beforeOpen: function() {
                    this.st.mainClass = this.st.el.attr('data-effect');
                }
            },
            type: 'inline',
            midClick: true
        });
    };

    //mobile filters
    $(document).on("click",".filter_open_btn .filter_btn",function () {
        $(".collection-sidebar.mobile-hide").slideToggle(400);
        $(this).children(".js-btn-filters").toggle();

    });
    $(document).on("click",'.collection-sidebar .collection-sidebar-widget',function () {
        open_close($(this));
    });
    $(document).on("click",'.blog-sidebar  .collection-sidebar-widget',function () {
        if($(window).outerWidth() < 768) {
            open_close($(this));
        }
    });
    function open_close(this_el) {
        if (this_el.hasClass("desctop-open-sidebar-widget") && $(window).outerWidth() >= 768) {
            return;
        }
        else {
            this_el.find(".arrows-filters").toggleClass('open');
            this_el.find(".mobile-slide").slideToggle(400);
        }
    }
    $(document).on('click','.imitation_btn',function () {
        let product = $(this).closest('.product-miniature');
        product.find('.main_btn-add-to-cart[type="submit"]').trigger('click');
    });

    //mobile menu
    $(".mobile-nav li>.arrow_menu").on("click",function () {
        $(this).parent("li").find(".megamenu-wrapper").slideToggle();
        $(this).parent("li").find(".site-nav__dropdown").slideToggle();
        $(this).parent("li").children(".site-nav__dropdown-last-level").slideToggle();
    });
//     $(".site-nav__childlist-item.has-dropdown .arrow_menu").on("click",function () { //THIS IS BREAKING THE MENU
//         if( $(window).outerWidth() < 992 ){
//       		console.log("TEST")
//             $(this).parent("li").find(".site-nav__dropdown-last-level ").slideToggle();
//         }
//     });
    var delay;
    $('.featured-products-tabs .tabs-content .tabs-item').each(function() {
        $(this).find('.product-miniature').each(function(i) {
            $(this).css('animation-delay','0.' + i + 's');
        });
        $(this).find('.grid__reveal').each(function(i) {
            delay = 0;
            delay = 0.3 + (i/10);
            $(this).css('animation-delay',delay + 's');
        });
    });

    // Size Guide
    $('.size_guide').add('.del_ret').magnificPopup({
        type: 'inline',
        removalDelay: 300,
        mainClass: 'my-mfp-zoom-in'
    });

    $('.js-option, .product-options').on('click change',function () {
        $(this).closest('.product-miniature').addClass('no-fade-effect');
        $(this).closest('.collection-list-item').addClass('no-fade-effect');
    });
    //
    $('.top_info_close').on('click',function () {
        $('.header-top-info').slideUp();
    });


    //Cookies Popup
    function cookies_popup() {
        let $cookies = $('.cookies_popup_block');
        if($cookies.length){
            if(localStorage.getItem('cookies_accept') != 'true' ){
                $cookies.css('display','block');
                let cookies_popup_height = $cookies.outerHeight();
                $cookies.css('display','none').slideDown();
                $('.scrolltopbtn').add('.buy_product_on_footer.product-single, .product_popup_block').css('margin-bottom',cookies_popup_height);
            }
            else{
                $('.scrolltopbtn').add('.buy_product_on_footer.product-single, .product_popup_block').add('.product_popup_block').css('margin-bottom','0');
            }
        }
    }
    cookies_popup();
    $('.cookies_popup_block .btn_cookies').on('click',function () {
        $('.cookies_popup_block').slideUp();
        localStorage.setItem('cookies_accept', 'true');
        $('.scrolltopbtn').add('.product_popup_block').add('.buy_product_on_footer.product-single').css('margin-bottom','0');
    });
    //Product buy footer Popup
    if($('.buy_product_on_footer ').length){
        let $buy_bar = $('.buy_product_on_footer');
        $(window).on('load scroll resize', function() {
            var product_offset_bottom = $('#product_page_content').offset().top + $('#product_page_content').height();
            if($('.product-single').hasClass('without_slider')) {
                product_offset_bottom = $(".without_slider .product-left").offset().top + $(".without_slider .product-left").height();
            }

            let cookies_footbar_height;
            if ( $(this).scrollTop() > product_offset_bottom) {
                $buy_bar.addClass('scroll');
                if(localStorage.getItem('cookies_accept') != 'true' ){
                    cookies_footbar_height = $('.cookies_popup_block').outerHeight() + $buy_bar.outerHeight();
                }
                else{
                    cookies_footbar_height = $buy_bar.outerHeight();
                }

                $('.scrolltopbtn').css('margin-bottom', $buy_bar.height());
                $('.product_popup_block').css('margin-bottom', 0);
                $('.product_popup_block').css('margin-bottom', cookies_footbar_height);
            }
            else{
                $buy_bar.removeClass('scroll');
                if(localStorage.getItem('cookies_accept') != 'true' ){
                    cookies_footbar_height = $('.cookies_popup_block').outerHeight();
                }
                else{
                    cookies_footbar_height = 0;
                }
                $('.scrolltopbtn').css('margin-bottom',0);
                $('.product_popup_block').css('margin-bottom', cookies_footbar_height);
            }
        });
    }

    //Product Popup
    function popup_product() {
        let $prod_popup = $('.product_popup_block');
        if($prod_popup.length){
            var min_interval = $prod_popup.attr('data-js-interval-min') * 1000;
            var max_interval = $prod_popup.attr('data-js-interval-max') * 1000;
            var max_products = $prod_popup.attr('data-products-count');
            var delay = $prod_popup.attr('data-js-delay') * 1000;

            function random_num(min,max) {
                return Math.floor(Math.random()*(max-min+1)+min);
            }
            var random_interval = random_num(min_interval,max_interval) + delay;
            var random_product = random_num(1,max_products);
            setInterval(
                function() {
                    var timeout;
                    $prod_popup.find(`.product_popup-item[data-product-index="${random_product}"]`).addClass('active').fadeIn();
                    clearTimeout(timeout);
                    timeout = setTimeout(
                        function() {
                            $prod_popup.find('.product_popup-item').removeClass('active').fadeOut();
                        }, delay);

                    random_interval = random_num(min_interval,max_interval) + delay;
                    random_product = random_num(1,max_products);
                }, random_interval);
        }
    }

    popup_product();
    $('.product_popup_close').on('click',function () {
        $('.product_popup_block').find('.product_popup-item').removeClass('active').fadeOut();
    });

    $('.lightbox-link').magnificPopup({
        type: 'image'
    });
    // Client service
    $('.close_cs_btn, .close_cs_frame').on('click', function(){
        $('.client_service_popup').addClass('close_cs');
        $('body').removeClass('overflow-hidden');
    });
    $('.cs_link-popup').on('click', function(){
        $('body').addClass('overflow-hidden');
        if($(this).hasClass('mobile-nav__item')){
            $('.js-drawer-close').trigger('click');
            $('.client_service_popup').removeClass('close_cs');
        }
        else{

            $('.client_service_popup').removeClass('close_cs');
        }
    });

    // Blog sidebar
    $('.bs-close-btn, .blog-sidebar_frame, .mobile_sidebar_button').on('click', function(){
        $('.blog-sidebar_popup').toggleClass('open_bs');
        $('body').toggleClass('overflow-hidden');
    });
    an_accordion();

 
});
$(document).ready(function () {
  $('.megamenu_items .shopify-section').removeAttr('data-shopify-editor-section');
});